import styled from "styled-components";

export const IconPickerContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px;
  height: 40px;
  background-color: ${({ theme }) => theme.bg.primary};
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  border: none;
  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.hover.black15};
    transition: background-color 0.1s ease;
  }
`;

export const IconPickerTile = styled.div`
  border: 1px solid ${({ theme }) => theme.border.black15};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.bg.secondary};
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const IconPickerLabel = styled.span`
  padding: 0 8px;
  font-size: 13px;
  text-overflow: ellipsis;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
`;

export const IconPickerTileContainer = styled.div`
  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;
`;
